<div class="container-fluid vh-100 d-flex align-items-center justify-content-center"
     *ngIf="screenState == screenStateType.Loading">
  <mat-spinner color="primary"></mat-spinner>
</div>
